module.exports = __webpack_public_path__ + "spine/dust_trail.json?dcd57065072670e3b9b9954fad6f89f3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spine/market_truck/dust_trail.json
// module id = 1751
// module chunks = 3